/*
Defines the custom element 
*/

import { RavelFluxlySoundEngine } from './src/RavelFluxlySoundEngine.js';

customElements.define('ravel-fluxly-sound-engine', RavelFluxlySoundEngine);
